import React from 'react';
import Layout from '../components/layout/Layout';

function AboutAppPage() {
  return (
    <Layout>
      <section className="section-about-banner">
        <div className="section-about-banner__container">
          <div className="section-about-banner__img">
            <div className="section-about-banner__text">
              <span className="section_about_header_name section-about-banner__main-headin">SunPanda</span>
              <h2 className="main-headin">О ПРИЛОЖЕНИИ</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="section-about-application">
        <div className="section-about-application__container">
          <div className="container">
            <h2 className="second-heading text-center mb-4">Страница в разработке</h2>
            <p className="text-center mb-5">Мы работаем над этим разделом. Скоро здесь появится информация о приложении.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default AboutAppPage;
